// extracted by mini-css-extract-plugin
export default {"percentageBar":"Percentage_percentageBar__zc4sn","bar-animation":"Percentage_bar-animation__onOGu"};